import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { FilingRestrictedModalComponent } from './components/filing-restricted-modal/filing-restricted-modal.component';

@NgModule({
  declarations: [FilingRestrictedModalComponent],
  imports: [CommonModule, TranslateModule, CustomModalModule],
  exports: [FilingRestrictedModalComponent],
})
export class FilingRestrictedModalModule {}
